module.exports = __webpack_public_path__ + "static/media/conejo_big.2006b19c.png";